// components/OrderSubscription.js
import {memo, useMemo} from "react";
import {useSubscribe} from "#src/contexts/SocketContext";

export const OrderSubscription = memo(({symbol, leverage}) => {
  const subscriptionTypes = useMemo(() => ["MAX_SIZE"], []);
  useSubscribe(subscriptionTypes, symbol, undefined, leverage);
  return null;
}, (prev, next) => prev.symbol === next.symbol && prev.leverage === next.leverage);
